import { AppImageDisplayInfo } from "client/Api/AppIcon/common";
import { AppColorViewModel } from "client/Api/Apps/common";
import {
	SearchNodeGroupDataSaveModel,
	GroupSearchNodeSaveModel,
	SearchNodeKind,
	ScopeSearchNodeSaveModel,
	SearchSettingsSaveModel
} from "client/Api/SearchSettings/searchSettings";
import {
	SearchIntegrationKind,
	GlobalSearchScopeKind
} from "client/Api/TitleBar/GlobalSearch/globalSearch";
import { ObjectWithClientId } from "client/Misc/clientId";
import { ensureNotNil } from "client/Misc/utils";
import { never } from "client_legacy/ndaw/errors";

export type IntegrationFlowData = {
	name: string;
	color: AppColorViewModel;
	imageDisplayInfo: AppImageDisplayInfo;
};

export type PredefinedScopeData = {
	name: string;
};

export type ScopesData = {
	integrationFlowsData: Map<number, IntegrationFlowData>;
	predefinedScopesData: Map<SearchIntegrationKind, PredefinedScopeData>;
};

export type ScopeItemFormModel = ObjectWithClientId<ScopeSearchNodeSaveModel>;

export type GroupFormData = OverrideProperties<
	SearchNodeGroupDataSaveModel,
	{
		scopes: readonly ScopeItemFormModel[];
	}
>;

export type GroupItemFormModel = ObjectWithClientId<
	OverrideProperties<
		GroupSearchNodeSaveModel,
		{
			groupData: GroupFormData;
		}
	>
>;

export type NodeItemFormModel =
	| GroupItemFormModel
	| ScopeItemFormModel;

export type FormModel = OverrideProperties<
	SearchSettingsSaveModel,
	{
		nodes: readonly NodeItemFormModel[];
	}
>;

export function getItemName(
	item: NodeItemFormModel,
	scopesData: ScopesData
): string {
	switch(item.kind) {
		case SearchNodeKind.Group:
			return item
				.groupData
				.name;
		case SearchNodeKind.Scope:
			return getScopeItemName(
				item,
				scopesData
			);
		default:
			never(item);
	}
}

function getScopeItemName(
	item: ScopeItemFormModel,
	scopesData: ScopesData
): string {
	const {
		scopeData: {
			scope
		}
	} = item;

	const {
		integrationFlowsData,
		predefinedScopesData
	} = scopesData;

	switch(scope.kind) {
		case GlobalSearchScopeKind.IntegrationFlow:
			return ensureNotNil(
				integrationFlowsData.get(scope.integrationId)
			)
				.name;
		case GlobalSearchScopeKind.Predefined:
			return ensureNotNil(
				predefinedScopesData.get(scope.predefinedKind)
			)
				.name;
		default:
			never(scope);
	}
}
